export default function(value, defaultValue, options) {
    if (arguments.length < 3) {
        throw new Error("Handlebars Helper equal needs 2 parameters");
    }
    if ( value == null) {
        value = defaultValue;
    }
    if (value) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
}
